import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Page, Fab, List, ListItem, BlockTitle, Block, Icon, Preloader, AccordionContent } from "framework7-react";
import _ from "lodash";

import HasRole from "modules/5_view_helpers/HasRole";
import AppNavbar from "modules/1_layout/mobile/AppNavbar";
import NotAuthorized from "modules/5_view_helpers/mobile/NotAuthorized";
import { getStoreRequests } from "../actions";

function mapStateToProps(state) {
  return {
    store_requests: state.store_requests,
  };
}

const StoreRequestsIndex = (props) => {
  const [loading, setLoading] = useState(false);
  const { store_requests } = props;
  const list = _.orderBy(_.values(store_requests || {}), ["created_at"], ["desc"]);

  const indexRole =
    HasRole(
      {
        resource_type: "Store::Request",
        name: ["create", "moderator"],
      },
      true,
    ) || HasRole({ name: "Show_All_Store_Requests" }, true);

  const createRole = HasRole(
    {
      resource_type: "Store::Request",
      name: ["create", "moderator"],
    },
    true,
  );

  useEffect(() => {
    if (indexRole) {
      setLoading(true);
      props.getStoreRequests().then(() => setLoading(false));
    }
  }, []);

  if (!indexRole) {
    return <NotAuthorized />;
  }

  return (
    <Page>
      <AppNavbar title="Store Requests" />

      {loading && <Preloader />}
      {!loading && (
        <Fragment>
          <BlockTitle>Recent requests</BlockTitle>
          <List accordionList>
            {_.map(list, (item) => (
              <ListItem
                key={item.id}
                accordionItem
                title={`#${item.id} — ${
                  item.tool_account
                    ? `Tool account${item.tool_account_employee?.display_name ? ` — ${item.tool_account_employee.display_name}` : ""}`
                    : item.mw_job_id || "—"
                }`}
                after={_.startCase(item.status)}
                footer={item.requested_by?.name}
              >
                <AccordionContent>
                  <Block>
                    {item.notes && (
                      <p>
                        <b>Notes:</b> {item.notes}
                      </p>
                    )}
                    <p>
                      <b>Line items</b>
                    </p>
                    <List>
                      {_.map(item.line_items || item.line_items_attributes || [], (li, i) => (
                        <ListItem key={li.id || i} title={li.description || "—"} after={`${li.quantity ?? "—"}`} />
                      ))}
                      {_.isEmpty(item.line_items || item.line_items_attributes) && <ListItem title="No line items" />}
                    </List>
                  </Block>
                </AccordionContent>
              </ListItem>
            ))}
          </List>
        </Fragment>
      )}

      {createRole && (
        <Fab position="right-bottom" slot="fixed" text="New" href="/store/requests/new">
          <Icon ios="f7:plus" aurora="f7:plus" md="material:add"></Icon>
        </Fab>
      )}
    </Page>
  );
};

export default connect(mapStateToProps, { getStoreRequests })(StoreRequestsIndex);
